// ===================================================
// components/Layout/NavBadge.jsx
// Compact NEW / HOT labels for sidebar + menu-guide.
// ===================================================
import React from 'react';

const NavBadge = ({ type }) => {
  if (type !== 'new' && type !== 'hot') return null;
  return (
    <span
      className={`mb-nav-badge mb-nav-badge--${type}`}
      title={type === 'hot' ? 'Популярное' : 'Новое'}
    >
      {type === 'hot' ? 'hot' : 'new'}
    </span>
  );
};

export default NavBadge;
